import React, { useEffect, useState } from "react";
import "./weChatCommon.scss";
import {
  captureWeChatContextFromSearch,
  clearWeChatContext,
  getWeChatQueryParameter,
} from "../../utils/weChatContext.utils";

const AUTH_URL = "/api-gateway/identity-wechat/identity/wechat/auth/auth-url";
const USERNAME_URL = "/account-center/wechat/wechat-username.html";

function WeChatComponent() {
  const [isLoading, setIsLoading] = useState(true);
  const search = window.location.search;
  window?.tfIdentityGlobals?.hideLoader();

  useEffect(() => {
    const isReg = getWeChatQueryParameter("isReg");

    if (isReg == null) {
      clearWeChatContext();
      window.location.href = `${AUTH_URL}${search}`;
      return;
    }

    captureWeChatContextFromSearch();

    if (isReg == "false") {
      window.location.replace(`${USERNAME_URL}${search}`);
      return;
    }

    setIsLoading(false);
  }, []);

  return (
    <div id="we-chat-wrapper">
      <div id="container">
        {isLoading && (
          <div className="loader">
            <div className="wc-loader"></div>
            <div className="loading-text">Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WeChatComponent;
